import manifest from './publicRouteManifest.json';

// Which public paths are kept out of search. This mirrors the build-side rules
// in scripts/public-routes.cjs (which also drive the sitemap), so a page's own
// robots tag and the sitemap can never disagree; publicRouteManifest.test.js
// checks every route against it.
const NOINDEX_PATHS = new Set([
  ...manifest.routes.filter((route) => !route.indexable).map((route) => route.path),
  ...(manifest.noindexModuleIds || []).map((id) => `/raf-cbat/${id}`),
  ...(manifest.noindexCfastModuleIds || []).map((id) => `/cfast/${id}`),
  ...(manifest.noindexCommercialModuleIds || []).map((id) => `/commercial-practice/${id}`)
]);

const normalize = (path) => {
  if (!path || path === '/') return '/';
  return `/${String(path).replace(/^\/+|\/+$/g, '')}`;
};

export const isNoindexPath = (path) => NOINDEX_PATHS.has(normalize(path));

export const robotsForPath = (path, indexable = 'index,follow') => (isNoindexPath(path) ? 'noindex,follow' : indexable);
